module.exports = __webpack_public_path__ + "static/media/bg-women-clothing.0fd34ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/component/modalConductor/topCategoriesModal/images/bg-women-clothing.jpg
// module id = 2135
// module chunks = 0